import { convertStatus, Status } from '../../../../api/enumerations';
import { FilterChip, QuickFiltersBox } from './styles';

const STATUS_ORDER: Status[] = [
  Status.ENTRANCE,
  Status.PEPT,
  Status.SCHEDULE,
  Status.INSPECTION,
  Status.SAMPLE_CREATION,
  Status.CALCULATION,
  Status.REPORT,
  Status.REVISION,
  Status.ARCHIVED,
];

interface StatusChipsProps {
  selected: Status[];
  onChange: (next: Status[]) => void;
  counters: Partial<Record<Status, number>>;
}

export function StatusChips({
  selected,
  onChange,
  counters,
}: StatusChipsProps): JSX.Element {
  const toggle = (status: Status): void => {
    if (selected.includes(status)) {
      onChange(selected.filter((s) => s !== status));
    } else {
      onChange([...selected, status]);
    }
  };

  return (
    <QuickFiltersBox>
      <span style={{ fontSize: 12, color: '#666', marginRight: 4 }}>
        status:
      </span>
      {STATUS_ORDER.map((status) => {
        const isActive = selected.includes(status);
        const count = counters[status] ?? 0;
        return (
          <FilterChip
            key={status}
            label={`${convertStatus(status)} (${count})`}
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            size="small"
            onClick={() => toggle(status)}
          />
        );
      })}
      {selected.length > 0 && (
        <FilterChip
          label="limpar"
          variant="outlined"
          size="small"
          onClick={() => onChange([])}
        />
      )}
    </QuickFiltersBox>
  );
}
